import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import RenderField from '../../generic/RenderedField';
import { validators } from '../../../redux/modules/utils/forms';
export default function () {
    return React.createElement('div', {
        'id': 'ForgotPassword',
        'className': 'auth-page'
    }, React.createElement('div', {}, React.createElement('div', { 'className': 'logo' }, React.createElement(Link, { 'to': '/' }, React.createElement('img', {
        'src': '/global/assets/images/logo/logo-big.png',
        'alt': 'Stan Winston School Of Character Arts'
    }))), React.createElement('div', { 'className': 'forgot-password-box auth-form-box' }, React.createElement('h1', {}, 'Forgot Password'), React.createElement('p', {}, '\n        Enter your Email address and we will send you an email with instructions\n        on how to change your password\n      '), React.createElement('form', {
        'id': 'SignInForm',
        'onSubmit': this.props.handleSubmit
    }, React.createElement(Field, {
        'name': 'email',
        'validate': validators.email,
        'component': RenderField,
        'type': 'email',
        'placeholder': 'Email',
        'props': { ariaLabel: 'Email' }
    }), React.createElement('button', {
        'type': 'submit',
        'className': 'btn -wide -blue-2',
        'disabled': this.props.pristine || this.props.submitting
    }, '\n          Send\n        ')), React.createElement('div', { 'className': 'auth-alt' }, '\n        or ', React.createElement(Link, { 'to': '/login' }, 'Sign In')))));
}